"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Item_1 = __importDefault(require("./Item/Item"));
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var IconItem_1 = __importDefault(require("../IconItem/IconItem"));
var localization_1 = require("@scuf/localization");
/**
 * The NotificationCenter is a child of the Header component that displays the number of notifications, along with a preview to a specified number of them.
 *  @child ./Item/Item.tsx
 */
var NotificationCenter = /** @class */ (function (_super) {
    __extends(NotificationCenter, _super);
    function NotificationCenter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genBadge = function () {
            var numOfNotifications;
            var _a = _this.props, children = _a.children, totalNumber = _a.totalNumber;
            if (React.Children.count(children) > 0) {
                if (totalNumber) {
                    numOfNotifications = totalNumber.toString();
                }
                else {
                    numOfNotifications = React.Children.count(children).toString();
                }
            }
            return numOfNotifications;
        };
        _this.renderFooter = function () {
            var onSeeAllClick = _this.props.onSeeAllClick;
            return onSeeAllClick &&
                React.createElement(localization_1.TranslationConsumer, null, function (t, lng) { return (React.createElement("div", { className: "see-all-container" },
                    React.createElement("div", { className: "see-all", onClick: function () { return onSeeAllClick(); } }, t('See all')))); });
        };
        return _this;
    }
    NotificationCenter.prototype.render = function () {
        var _a = this.props, count = _a.count, badgeColor = _a.badgeColor, linkToAll = _a.linkToAll, children = _a.children, maxNumToPreview = _a.maxNumToPreview, onSeeAllClick = _a.onSeeAllClick, totalNumber = _a.totalNumber, rest = __rest(_a, ["count", "badgeColor", "linkToAll", "children", "maxNumToPreview", "onSeeAllClick", "totalNumber"]);
        return (React.createElement(Dropdown_1.default, __assign({}, rest, { className: "notification-center", item: true, simple: true, upward: false, direction: "left", icon: "", trigger: React.createElement("span", { className: "trigger-container" },
                React.createElement(IconItem_1.default, { icon: "notification", badgeColor: badgeColor, badge: this.genBadge(), description: "Notifications", className: "trigger-icon" }),
                React.createElement("span", { className: "responsive-trigger-label" }, "Notifications")) }),
            React.createElement(Dropdown_1.default.Menu, { className: "notification-center-dropdown" },
                children,
                this.renderFooter())));
    };
    NotificationCenter.Item = Item_1.default;
    NotificationCenter.defaultProps = {
        badgeColor: 'red'
    };
    return NotificationCenter;
}(React.Component));
exports.default = NotificationCenter;
